class Product{
    constructor(json){
        this.amazing=json.amazing;
        this.amazing_remained_time=json.amazing_remained_time;
        this.cat_product_id=json.cat_product_id;
        this.product_description=json.product_description;
        this.product_discounts=(json.product_discounts!=null)?json.product_discounts:json.discounts;
        this.product_id=(json.product_id!=null)?json.product_id:json.id;
        this.product_image=json.product_image;
        this.product_name=(json.product_name!=null)?json.product_name:json.title;
        this.product_number=json.product_number;
        this.product_price=(json.product_price!=null)?json.product_price:json.price;
        this.store_name=(json.store_name!=null)?json.store_name:json.stores.store_name;
        this.product_unit=(json.product_unit!=null)?json.product_unit:json.unit;
    }
}

export default Product;